import { lazy } from 'react';
import withSuspense from 'utils/withSuspense';
const CategoriesIndex = lazy(() => import('features/contact-form/components/CategoriesIndex'));

const CategoriesIndexRoute = withSuspense(CategoriesIndex);

export default CategoriesIndexRoute;
